module.exports = __webpack_public_path__ + "static/FullSizeRender-about-98f7bea4a160eb24788c371db275552b.png";